import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'toYear'
})

export class Date2YearPipe implements PipeTransform {
    transform(value: string): any {
        if (!value)
            return value;

        return value.replace(new RegExp('-[0-9][0-9]-[0-9][0-9]T.+', 'gi'), '');
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/date2year.pipe.ts